import type { Song } from "@/types";
import Visibility from "@mui/icons-material/Visibility";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

function AdminSongViews({ song }: { song: Song }) {
  if (!song.views || song.views <= 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
      <Visibility fontSize="inherit" />
      <Typography sx={{ ml: 0.5 }}>
        {song.views}
      </Typography>
    </Box>
  );
}

export default AdminSongViews;